import * as React from "react";
import Dialog from "@mui/material/Dialog";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import Slide from "@mui/material/Slide";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Collapse from "@mui/material/Collapse";
import Divider from "@mui/material/Divider";
import Button from "@mui/material/Button";
import BusinessIcon from "@mui/icons-material/Business";
import StoreIcon from "@mui/icons-material/Store";
import TelegramIcon from "@mui/icons-material/Telegram";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import { useState } from "react";
import QrCodeDialog from "./CodeDialog";
import { useDispatch, useSelector } from "react-redux";
import dayjs from "dayjs";

// Transition for the slide animation
const Transition = React.forwardRef(function Transition(
  props, // No type annotations here
  ref
) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const SummaryServiceDialog = ({
  data,
  dataConstraintList,
  dataDownPaymentList,
  dataPartList,
  dataServiceTypeList,
  openSummaryService,
  handleCloseSummaryService,
}) => {
  // console.log("Ini data detail", data);
  // console.log("Ini data ConstraintList", dataConstraintList);
  // console.log("Ini data DownPaymentList", dataDownPaymentList);
  // console.log("Ini data PartList", dataPartList);
  // console.log("Ini data ServiceTypeList", dataServiceTypeList);
  const [openDaftarKendala, setOpenDaftarKendala] = useState(false);
  const [openJasaService, setOpenJasaService] = useState(false);
  const [openSparepart, setOpenSparepart] = useState(false);
  const [openUangMuka, setOpenUangMuka] = useState(false);
  const [openQRCode, setOpenQRCode] = useState(false);
  const currentUserId = useSelector((state) => state.user.currentUserId);
  const user = useSelector(
    (state) => state.user.users[state.user.currentUserId]
  );
  const dispatch = useDispatch();

  const handleOpenQRCode = () => {
    setOpenQRCode(true);
  };
  const handleCloseQRCode = () => {
    setOpenQRCode(false);
  };
  return (
    <Dialog
      fullScreen
      open={openSummaryService}
      onClose={handleCloseSummaryService}
      TransitionComponent={Transition}
    >
      <AppBar sx={{ position: "relative" }}>
        <Toolbar>
          <IconButton
            edge="start"
            color="inherit"
            onClick={handleCloseSummaryService}
            aria-label="close"
          >
            <ArrowBackIcon />
          </IconButton>
          <Typography
            sx={{ ml: 2, flex: 1, textAlign: "center" }}
            variant="h6"
            component="div"
          >
            Summary Service
          </Typography>
        </Toolbar>
      </AppBar>
      <Box sx={{ p: 2, borderRadius: 3, bgcolor: "#f5f5f5", mb: 2 }}>
        <Box
          sx={{
            p: 2,
            borderRadius: 5,
            bgcolor:
              data?.status == 1
                ? "#1976d2" // primary
                : data?.status == 2
                ? "#ed6c02" // warning
                : data?.status == 3
                ? "#2e7d32" // success
                : data?.status == 4
                ? "#1976d2" // primary
                : data?.status == 5
                ? "#2e7d32" // success
                : data?.status == 6
                ? "#d32f2f" // error
                : "#9e9e9e", // default/unknown
            boxShadow: 1,
            mb: 1,
            textAlign: "center",
          }}
        >
          <Typography
            variant="body2"
            sx={{ color: "white", fontWeight: 500 }}
            display="block"
          >
            {data?.status == 1
              ? "Diterima"
              : data?.status == 2
              ? "Diproses"
              : data?.status == 3
              ? "Selesai"
              : data?.status == 4
              ? "Dibayar"
              : data?.status == 5
              ? "Diklaim"
              : data?.status == 6
              ? "Dibatalkan"
              : "-"}
          </Typography>
        </Box>

        <Box
          sx={{
            p: 2,
            borderRadius: 2,
            bgcolor: "#ffffff",
            boxShadow: 1,
            mb: 1,
          }}
        >
          {/* Baris utama (rounded dan text) */}
          <Box sx={{ display: "flex", alignItems: "center", mb: 1 }}>
            <Box
              sx={{
                width: 40,
                height: 40,
                borderRadius: "50%",
                backgroundColor: "#f8bbd0",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                mr: 2,
              }}
            ></Box>
            <Box>
              <Typography
                variant="caption"
                color="text.secondary"
                display="block"
              >
                Teknisi
              </Typography>
              <Typography
                variant="body2"
                color="text.primary"
                fontWeight="bold"
              >
                {user?.name ? user?.name : "-"}
              </Typography>
            </Box>
          </Box>

          {/* Baris baru di bawahnya */}
          {/* <Box sx={{ display: "flex", alignItems: "center", mb: 1 }}>
            <BusinessIcon sx={{ color: "#3f51b5", fontSize: 20, mr: 1 }} />
            <Typography variant="body2" color="text.primary" fontWeight="bold">
              PT Solusi Teknologi
            </Typography>
          </Box>
          <Box sx={{ display: "flex", alignItems: "center" }}>
            <StoreIcon sx={{ color: "#3f51b5", fontSize: 20, mr: 1 }} />
            <Typography variant="body2" color="text.primary" fontWeight="bold">
              Citywalk Sudirman
            </Typography>
          </Box> */}
        </Box>

        <Box
          sx={{
            p: 2,
            borderRadius: 2,
            bgcolor: "#ffffff",
            boxShadow: 1,
            mb: 1,
          }}
        >
          <Box sx={{ mb: 2 }}>
            <Typography
              variant="caption"
              color="text.secondary"
              display="block"
            >
              Nama Device
            </Typography>
            <Typography variant="body2" color="text.primary" fontWeight="bold">
              {data?.device_name ? data?.device_name : "-"}
            </Typography>
          </Box>
          <Box sx={{ mb: 2 }}>
            <Typography
              variant="caption"
              color="text.secondary"
              display="block"
            >
              Tanggal Service
            </Typography>
            <Typography variant="body2" color="text.primary" fontWeight="bold">
              {dayjs(data?.date).format("DD MMM YYYY HH.mm")
                ? dayjs(data?.date).format("DD MMM YYYY HH.mm")
                : "-"}
            </Typography>
          </Box>
          <Box sx={{ mb: 2 }}>
            <Typography
              variant="caption"
              color="text.secondary"
              display="block"
            >
              Kode
            </Typography>
            <Typography variant="body2" color="text.primary" fontWeight="bold">
              {data?.code ? data?.code : "-"}
            </Typography>
          </Box>
          {/* <Box sx={{ mb: 2 }}>
            <Button
              fullWidth
              sx={{
                p: 2,
                borderRadius: 5,
                bgcolor: "transparent",
                boxShadow: 1,
                mb: 1,
                color: "#ff1744",
                textTransform: "none",
                border: "1px solid #ff1744",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                "&:hover": {
                  bgcolor: "rgba(255, 23, 68, 0.1)",
                },
              }}
              onClick={handleOpenQRCode}
            >
              <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                <TelegramIcon />
                <Typography variant="body1">Bagikan Kode QR</Typography>
              </Box>
            </Button>
          </Box> */}
          <Divider sx={{ mb: 2 }} />
          <Box display="flex" alignItems="center" gap={10}>
            <Box>
              <Typography
                variant="caption"
                color="text.secondary"
                display="block"
              >
                Pelanggan
              </Typography>
              <Typography
                variant="body2"
                fontWeight="bold"
                color="text.primary"
                display="block"
              >
                {data?.customer_name ? data?.customer_name : "-"}
              </Typography>
            </Box>
            <Box sx={{ mb: 2 }}>
              <Typography
                variant="body2"
                color="text.secondary"
                display="block"
              >
                Durasi
              </Typography>
              <Typography
                variant="body2"
                fontWeight="bold"
                color="text.primary"
                display="block"
              >
                {data?.warranty_duration ? data?.warranty_duration : "-"}
              </Typography>
            </Box>
          </Box>
          <Box display="flex" alignItems="center" gap={10}>
            <Box>
              <Typography
                variant="caption"
                color="text.secondary"
                display="block"
              >
                No. IMEI/SN
              </Typography>
              <Typography
                variant="body2"
                fontWeight="bold"
                color="text.primary"
                display="block"
              >
                {data?.serial_number ? data?.serial_number : "-"}
              </Typography>
            </Box>
            <Box sx={{ mb: 2 }}>
              <Typography
                variant="body2"
                color="text.secondary"
                display="block"
              >
                Kondisi
              </Typography>
              <Typography
                variant="body2"
                fontWeight="bold"
                color="text.primary"
                display="block"
              >
                {data?.conditions ? data?.conditions : "-"}
              </Typography>
            </Box>
          </Box>
          <Box display="flex" alignItems="center" gap={10}>
            <Box>
              <Typography
                variant="caption"
                color="text.secondary"
                display="block"
              >
                Kapasitas
              </Typography>
              <Typography
                variant="body2"
                fontWeight="bold"
                color="text.primary"
                display="block"
              >
                {data?.storage_name ? data?.storage_name : "-"}
              </Typography>
            </Box>
            <Box sx={{ mb: 2 }}>
              <Typography
                variant="body2"
                color="text.secondary"
                display="block"
              >
                Warna
              </Typography>
              <Typography
                variant="body2"
                fontWeight="bold"
                color="text.primary"
                display="block"
              >
                {data?.color_name ? data?.color_name : "-"}
              </Typography>
            </Box>
          </Box>
          <Box display="flex" alignItems="center" gap={10}>
            <Box>
              <Typography
                variant="caption"
                color="text.secondary"
                display="block"
              >
                Prioritas
              </Typography>
              <Typography
                variant="body2"
                fontWeight="bold"
                color="text.primary"
                display="block"
              >
                {data?.priority ? data?.priority : "-"}
              </Typography>
            </Box>
            <Box sx={{ mb: 2 }}>
              <Typography
                variant="body2"
                color="text.secondary"
                display="block"
              >
                Dititipkan
              </Typography>
              <Typography
                variant="body2"
                fontWeight="bold"
                color="text.primary"
                display="block"
              >
                {data?.is_entrusted ? data?.is_entrusted : "-"}
              </Typography>
            </Box>
          </Box>
          <Box>
            <Typography
              variant="caption"
              color="text.secondary"
              display="block"
            >
              Keterangan
            </Typography>
            <Typography variant="body2" color="text.primary" fontWeight="bold">
              {data?.transaction_notes ? data?.transaction_notes : "-"}
            </Typography>
          </Box>

          {data?.status === 6 ? (
            <Box>
              <Divider sx={{ mb: 2 }} />
              <Box sx={{ mb: 2 }}>
                <Typography
                  variant="body2"
                  color="text.primary"
                  fontWeight="bold"
                >
                  Informasi Pembatalan
                </Typography>
              </Box>
              <Box sx={{ mb: 2 }}>
                <Typography
                  variant="caption"
                  color="text.secondary"
                  display="block"
                >
                  Otoritasasi Oleh
                </Typography>
                <Typography
                  variant="body2"
                  color="text.primary"
                  fontWeight="bold"
                >
                  {user?.name ? user?.name : "-"}
                </Typography>
              </Box>
              <Box>
                <Typography
                  variant="caption"
                  color="text.secondary"
                  display="block"
                >
                  Alasan Pembatalan
                </Typography>
                <Box
                  sx={{
                    bgcolor: "#e0e0e0",
                    pointerEvents: "none",
                    p: 2,
                    borderRadius: 3,
                  }}
                >
                  <Typography variant="body2" color="#000" display="block">
                    {data?.transaction_notes ? data?.transaction_notes : "-"}
                  </Typography>
                </Box>
              </Box>
            </Box>
          ) : null}
        </Box>
        {/* Header dengan tombol panah */}
        <Box
          sx={{
            p: 2,
            borderRadius: 2,
            bgcolor: "#ffffff",
            boxShadow: 1,
            mb: 1,
            display: "flex",
            flexDirection: "column",
          }}
        >
          {/* Header Daftar Kendala */}
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
          >
            <Typography variant="body2" color="text.primary" fontWeight="bold">
              Daftar Kendala
            </Typography>
            <IconButton
              onClick={() => setOpenDaftarKendala(!openDaftarKendala)}
              size="small"
            >
              {openDaftarKendala ? (
                <KeyboardArrowUpIcon />
              ) : (
                <KeyboardArrowDownIcon />
              )}
            </IconButton>
          </Box>

          {/* Detail Daftar Kendala */}
          <Collapse in={openDaftarKendala}>
            <Box mt={2}>
              {dataConstraintList && dataConstraintList.length > 0 ? (
                dataConstraintList.map((item, index) => (
                  <Box
                    key={index}
                    sx={{
                      bgcolor: "#e0e0e0",
                      pointerEvents: "none",
                      p: 2,
                      borderRadius: 3,
                      mb: 1,
                    }}
                  >
                    <Typography variant="body2" color="#000" display="block">
                      {item.constraint_name}
                    </Typography>
                  </Box>
                ))
              ) : (
                <Box
                  sx={{
                    bgcolor: "#e0e0e0",
                    pointerEvents: "none",
                    p: 2,
                    borderRadius: 3,
                  }}
                >
                  <Typography variant="body2" color="#000" display="block">
                    -
                  </Typography>
                </Box>
              )}
            </Box>
          </Collapse>
        </Box>

        {/* Header dengan tombol panah */}
        <Box
          sx={{
            p: 2,
            borderRadius: 2,
            bgcolor: "#ffffff",
            boxShadow: 1,
            mb: 1,
            display: "flex",
            flexDirection: "column",
          }}
        >
          {/* Header Jasa Service */}
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
          >
            <Typography variant="body2" color="text.primary" fontWeight="bold">
              Jasa Service
            </Typography>
            <IconButton
              onClick={() => setOpenJasaService(!openJasaService)}
              size="small"
            >
              {openJasaService ? (
                <KeyboardArrowUpIcon />
              ) : (
                <KeyboardArrowDownIcon />
              )}
            </IconButton>
          </Box>

          {/* Detail Jasa Service */}
          <Collapse in={openJasaService}>
            {dataServiceTypeList && dataServiceTypeList.length > 0 ? (
              <>
                {dataServiceTypeList.map((item, index) => (
                  <Box mt={2} key={index}>
                    <Box
                      sx={{
                        bgcolor: "#e0e0e0",
                        pointerEvents: "none",
                        p: 2,
                        borderRadius: 3,
                      }}
                    >
                      <Box>
                        <Typography
                          variant="body2"
                          color="#000"
                          fontWeight="bold"
                        >
                          {item.service_type_name}
                        </Typography>
                        <Typography variant="caption" color="#000">
                          {
                            // hitung total jika value berupa angka
                            dataServiceTypeList
                              .reduce((sum, item) => {
                                const num = parseInt(
                                  item.service_fee.replace(/[^\d]/g, ""),
                                  10
                                );
                                return sum + (isNaN(num) ? 0 : num);
                              }, 0)
                              .toLocaleString("id-ID", {
                                style: "currency",
                                currency: "IDR",
                              })
                          }
                        </Typography>
                      </Box>
                    </Box>
                  </Box>
                ))}
                {/* TOTAL */}
                <Box mt={2}>
                  <Box
                    sx={{
                      bgcolor: "#e0e0e0",
                      pointerEvents: "none",
                      p: 2,
                      borderRadius: 3,
                    }}
                  >
                    <Box
                      display="flex"
                      justifyContent="space-between"
                      alignItems="center"
                      gap={2}
                      sx={{ width: "100%" }}
                    >
                      <Typography
                        variant="body2"
                        color="#000"
                        fontWeight="bold"
                      >
                        TOTAL
                      </Typography>
                      <Typography variant="caption" color="#000">
                        {
                          // hitung total jika value berupa angka
                          dataServiceTypeList
                            .reduce((sum, item) => {
                              const num = parseInt(
                                item.service_fee.replace(/[^\d]/g, ""),
                                10
                              );
                              return sum + (isNaN(num) ? 0 : num);
                            }, 0)
                            .toLocaleString("id-ID", {
                              style: "currency",
                              currency: "IDR",
                            })
                        }
                      </Typography>
                    </Box>
                  </Box>
                </Box>
              </>
            ) : (
              <>
                {/* Default LCD */}
                <Box mt={2}>
                  <Box
                    sx={{
                      bgcolor: "#e0e0e0",
                      pointerEvents: "none",
                      p: 2,
                      borderRadius: 3,
                    }}
                  >
                    <Box>
                      <Typography
                        variant="body2"
                        color="#000"
                        fontWeight="bold"
                      >
                        -
                      </Typography>
                      <Typography variant="caption" color="#000">
                        -
                      </Typography>
                    </Box>
                  </Box>
                </Box>
                {/* Default TOTAL */}
                <Box mt={2}>
                  <Box
                    sx={{
                      bgcolor: "#e0e0e0",
                      pointerEvents: "none",
                      p: 2,
                      borderRadius: 3,
                    }}
                  >
                    <Box
                      display="flex"
                      justifyContent="space-between"
                      alignItems="center"
                      gap={2}
                      sx={{ width: "100%" }}
                    >
                      <Typography
                        variant="body2"
                        color="#000"
                        fontWeight="bold"
                      >
                        TOTAL
                      </Typography>
                      <Typography variant="caption" color="#000">
                        -
                      </Typography>
                    </Box>
                  </Box>
                </Box>
              </>
            )}
          </Collapse>
        </Box>
        {/* Header dengan tombol panah */}
        <Box
          sx={{
            p: 2,
            borderRadius: 2,
            bgcolor: "#ffffff",
            boxShadow: 1,
            mb: 1,
            display: "flex",
            flexDirection: "column",
          }}
        >
          {/* Header Sparepart */}
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
          >
            <Typography variant="body2" color="text.primary" fontWeight="bold">
              Sparepart
            </Typography>
            <IconButton
              onClick={() => setOpenSparepart(!openSparepart)}
              size="small"
            >
              {openSparepart ? (
                <KeyboardArrowUpIcon />
              ) : (
                <KeyboardArrowDownIcon />
              )}
            </IconButton>
          </Box>

          {/* Detail Daftar Sparepart */}
          <Collapse in={openSparepart}>
            <Box mt={2}>
              {dataPartList && dataPartList.length > 0 ? (
                dataPartList.map((item, index) => (
                  <Box
                    key={index}
                    sx={{
                      bgcolor: "#e0e0e0",
                      pointerEvents: "none",
                      p: 2,
                      borderRadius: 3,
                      mb: 1, // memberi jarak antar part
                    }}
                  >
                    <Typography variant="body2" color="#000" display="block">
                      {item.part_name}
                    </Typography>
                  </Box>
                ))
              ) : (
                <Box
                  sx={{
                    bgcolor: "#e0e0e0",
                    pointerEvents: "none",
                    p: 2,
                    borderRadius: 3,
                  }}
                >
                  <Typography variant="body2" color="#000" display="block">
                    -
                  </Typography>
                </Box>
              )}
            </Box>
          </Collapse>
        </Box>
        {/* Header dengan tombol panah */}
        <Box
          sx={{
            p: 2,
            borderRadius: 2,
            bgcolor: "#ffffff",
            boxShadow: 1,
            mb: 1,
            display: "flex",
            flexDirection: "column",
          }}
        >
          {/* Header Uang Muka */}
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
          >
            <Typography variant="body2" color="text.primary" fontWeight="bold">
              Uang Muka (DP)
            </Typography>
            <IconButton
              onClick={() => setOpenUangMuka(!openUangMuka)}
              size="small"
            >
              {openUangMuka ? (
                <KeyboardArrowUpIcon />
              ) : (
                <KeyboardArrowDownIcon />
              )}
            </IconButton>
          </Box>

          {/* Detail Uang Muka */}
          <Collapse in={openUangMuka}>
            {dataDownPaymentList && dataDownPaymentList.length > 0 ? (
              dataDownPaymentList.map((item, index) => (
                <Box mt={2} key={index}>
                  <Box
                    sx={{
                      bgcolor: "#e0e0e0",
                      pointerEvents: "none",
                      p: 2,
                      borderRadius: 3,
                    }}
                  >
                    {/* Tanggal & Ikon */}
                    <Box
                      sx={{
                        mb: 2,
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                      }}
                    >
                      <Box>
                        <Typography variant="body2" color="#000">
                          Tanggal Uang Muka (DP)
                        </Typography>
                        <Typography
                          variant="caption"
                          color="#000"
                          fontWeight="bold"
                        >
                          {item.date}
                        </Typography>
                      </Box>
                      <IconButton
                        size="small"
                        sx={{
                          bgcolor: "rgba(33, 150, 243, 0.2)",
                          color: "#2196f3",
                          borderRadius: "50%",
                          p: 0.5,
                          ml: 2,
                          "&:hover": {
                            bgcolor: "rgba(33, 150, 243, 0.3)",
                          },
                        }}
                      >
                        <ErrorOutlineIcon fontSize="small" />
                      </IconButton>
                    </Box>

                    {/* Status & Amount */}
                    <Box
                      display="flex"
                      justifyContent="space-between"
                      alignItems="center"
                      gap={2}
                      sx={{ width: "100%" }}
                    >
                      <Typography variant="body2" color="#000">
                      {(() => {
                        switch (item.status) {
                          case 1:
                            return "Diterima";
                          case 2:
                            return "Diproses";
                          case 3:
                            return "Selesai";
                          case 4:
                            return "Dibayar";
                          case 5:
                            return "Diklaim";
                          case 6:
                            return "Dibatalkan";
                          default:
                            return "-";
                        }
                      })()}
                      </Typography>
                      <Typography
                        variant="caption"
                        color="#000"
                        fontWeight="bold"
                      >
                        {item.total_amount}
                      </Typography>
                    </Box>
                  </Box>
                </Box>
              ))
            ) : (
              <Box mt={2}>
                <Box
                  sx={{
                    bgcolor: "#e0e0e0",
                    pointerEvents: "none",
                    p: 2,
                    borderRadius: 3,
                  }}
                >
                  <Box
                    sx={{
                      mb: 2,
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                    }}
                  >
                    <Box>
                      <Typography variant="body2" color="#000">
                        Tanggal Uang Muka (DP)
                      </Typography>
                      <Typography
                        variant="caption"
                        color="#000"
                        fontWeight="bold"
                      >
                        -
                      </Typography>
                    </Box>
                    <IconButton
                      size="small"
                      sx={{
                        bgcolor: "rgba(33, 150, 243, 0.2)",
                        color: "#2196f3",
                        borderRadius: "50%",
                        p: 0.5,
                        ml: 2,
                        "&:hover": {
                          bgcolor: "rgba(33, 150, 243, 0.3)",
                        },
                      }}
                    >
                      <ErrorOutlineIcon fontSize="small" />
                    </IconButton>
                  </Box>
                  <Box
                    display="flex"
                    justifyContent="space-between"
                    alignItems="center"
                    gap={2}
                    sx={{ width: "100%" }}
                  >
                    <Typography variant="body2" color="#000">
                      -
                    </Typography>
                    <Typography
                      variant="caption"
                      color="#000"
                      fontWeight="bold"
                    >
                      -
                    </Typography>
                  </Box>
                </Box>
              </Box>
            )}
          </Collapse>
        </Box>
      </Box>

      <Box
        sx={{
          p: 2,
          borderRadius: 2,
          bgcolor: "#ffffff",
          boxShadow: 1,
          cursor: "pointer",
          mb: 1,
        }}
      >
        <Button
          variant="contained"
          fullWidth
          sx={{
            textTransform: "none",
            bgcolor: "#424242",
            borderRadius: 5,
            ":hover": {
              bgcolor: "#08306b",
            },
          }}
          onClick={handleCloseSummaryService}
        >
          Kembali
        </Button>
      </Box>

      <QrCodeDialog
        openQRCode={openQRCode}
        handleCloseQRCode={handleCloseQRCode}
      />
    </Dialog>
  );
};

export default SummaryServiceDialog;
